export default "__VITE_ASSET__dQhssVN5__"